/*******
Common Function Used In Diamond Listing & Detail Page 
********/

/*** Pre Define Constant Values For Webservice Call ***/
const api = "https://autumn.buildzone.net/live/graphql/";
const naturalDiamondListingApi = "diamondData";
const labDiamondListingApi = "diamondData";
// const rapnetDiamondDetailApi = "rapnetDiamondById";
const naturalDiamondDetailApi = "diamondById";
const labDiamondDetailApi = "diamondById";
const diamondSearchByReportApi = "diamondByStockorcert";
const naturalDiamondAddToCart = "diamondAddToCart";
const labDiamondAddToCart = "diamondAddToCart";
/*** End ***/

/*** Store Language Code ***/
const store_lang = window.Shopify.locale;
/*** End ***/

/*** AddCommas in price start ***/
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
/*** addCommas in price end ***/

/*** Get Certificate File URL Start ***/
function getCertificateUrl(diamondData) {
  var certificateFile = '';
  var diaLab = diamondData.lab;
  var diaCertNo = diamondData.certificateNumber;
  var diaCarat = diamondData.caratWeight;
  
  if(diamondData.certificateFile != ''){
    certificateFile = diamondData.certificateFile;
  }else{
    switch(diaLab)
      {
        case "GIA":
            certificateFile = 'https://www.gia.edu/cs/Satellite?reportno='+diaCertNo+'&childpagename=GIA%2FPage%2FReportCheck&pagename=GIA%2FDispatcher&c=Page&cid=1355954554547#main-content';
            break;
        case "IGI":
            certificateFile = 'https://www.igi.org/verify-your-report/?r='+diaCertNo;
            break;
        case "HRD":
            certificateFile = 'https://my.hrdantwerp.com/?record_number='+diaCertNo+'&weight='+diaCarat;
            break;
        case "AGS":
            certificateFile = 'https://www.agslab.com/reportTypes/pdqr.php?StoneID='+diaCertNo+'&Weight='+diaCarat+'&D=1';
            break;
        default:
            certificateFile = "";
      }
  }    
  return certificateFile;
}
/*** End ***/

/*** Diamond Broken Image Fixes start ***/ 
function imgError(image,defaultImage) {
  image.onerror = "";
  image.src = defaultImage;
  return true;
}
/*** End ***/  

/*** Get Diamond Default Final Price Field Start ***/
function getDiamondDefaultFinalPriceField(currencyCode){
  var diamond_price_field;
	switch (currencyCode) {		
		case "EUR":
			diamond_price_field = "finalPriceEur";
			break;
		case "GBP":
			diamond_price_field = "finalPriceGbp";
			break;
		case "USD":
			diamond_price_field = "finalPriceUsd";
			break;		
		default:
			diamond_price_field = "finalPriceGbp"
	}
	return diamond_price_field;
}
/*** End ***/  

/*** Get Diamond Price Start ***/
function getDiamondPrice(currency_rate,finalPrice) {  
  //console.log('currencyRate',currencyRate);
  var final_dia_price = finalPrice * currency_rate; 
  var dia_formatted_price = Math.ceil(final_dia_price);      
  dia_formatted_price = Shopify.formatMoney(dia_formatted_price * 100, theme.moneyFormat);
  dia_formatted_price = dia_formatted_price.replace(/([.,])00$/, '');
  return dia_formatted_price;
}
/*** End ***/

/*** Get Diamond Type Start ***/
function getDiamondType(diamondType) {
  var type = diamondType;
  if(type == 'natural-white' || type == 'natural-fancy'){
    dia_type = translations.titleNatural;
  }else{
    dia_type = translations.titleLabGrown;
  }
  return dia_type;
}
/*** End ***/

/*** Get Diamond Name Start ***/
function getDiamondName(diamondData,diamondType) {
  var diamond_name = diamondData.caratWeight + "-Carat " + diamondData.shape + " Shape "+ diamondType +" Diamond ";
  return diamond_name;
}
/*** End ***/

/*** Get Diamond measurement Start ***/
function getDiamondMeasurement(diamondData) {
  if(diamondData.measurement != ''){
    var measurements = diamondData.measurement;
  }else{
    var measurements = diamondData.length + " * " + diamondData.width + " * " + diamondData.depth;
  }  
  return measurements;
}
/*** End ***/

/*** Get Diamond Girdle Start ***/
function getDiamondGirdle(diamondData) {
  if(diamondData.girdleMin != '' && diamondData.girdleMax != ''){
    var girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
  }else if(diamondData.girdleMax == ''){
    var girdle = diamondData.girdleMin;
  }else if(diamondData.girdleMin == ''){
    var girdle = diamondData.girdleMax;
  }else{
    var girdle = 'NA';
  }  
  return girdle;
}
/*** End ***/

/*** Get Diamond Detail Information Layout ***/
function getDiamondInformationLayout(diamondData) {
 
  var diamond_certificate_url = getCertificateUrl(diamondData);
  var diamond_measurements = getDiamondMeasurement(diamondData);
  
  var diamond_ratio = diamondData.ratio;
   if(diamond_ratio == '0.0'){
     // var dia_ratio = '-';
     dia_ratio = diamondData.length/diamondData.width;
     dia_ratio = dia_ratio.toFixed(2);
   }else{
     dia_ratio = diamond_ratio;
   }

  var diamond_girdle = diamondData.girdle;
  if(diamond_girdle == null || diamond_girdle == undefined){
    // if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
    //   diamond_girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
    // }else{
    //   diamond_girdle = "-";
    // }   

    diamond_girdle = getDiamondGirdle(diamondData);
  }

  var diamond_intensity = diamondData.fancyColorIntensity;
  if(diamond_intensity == null || diamond_intensity == undefined) {
      diamond_intensity = "";
  }

  var diamond_overtone = diamondData.fancyColorOvertone;
  if(diamond_overtone == null || diamond_overtone == undefined) {
      diamond_overtone = "";
  }
  
  //Dynamic Diamond Information Array 
  var diamondInformation = {
   // "diamondStockId" : translations.titleStockID+' - '+diamondData.stockNumber,
    "diamondReportNo" : translations.titleReportID+' - '+diamondData.certificateNumber,
    "diamondReport"  : translations.titleGradingReport+' - '+diamondData.lab+' - '+diamond_certificate_url,
    "diamondShape"   : translations.titleShape+' - '+diamondData.shape,
    "diamondCarat"   : translations.titleCaratWeight+' - '+diamondData.caratWeight,
    "diamondColor"   : translations.titleColor+' - '+diamondData.color,
    "diamondFancyColor" : translations.titleColor+' - '+diamondData.fancyColor,
    "diamondClarity" : translations.titleClarity+' - '+diamondData.clarity,
    "diamondCut"     : translations.titleCut+' - '+diamondData.cut,      
    "diamondPolish"  : translations.titlePolish+' - '+diamondData.polish,  
    "diamondSymmetry": translations.titleSymmetry+' - '+diamondData.symmetry,
    "diamondFluorescence" : translations.titleFluorescence+' - '+diamondData.flourIntensity,
    "diamondTable"   : translations.titleTable+' - '+diamondData.tablePerc,
    "diamondDepth"   : translations.titleDepth+' - '+diamondData.deptPerc,
    "diamondRatio"   : translations.titleRatio+' - '+dia_ratio,
    "diamondMeasurement" : translations.titleMeasurement+' - '+diamond_measurements,   
    "diamondGirdle"  : translations.titleGirdle+' - '+diamond_girdle,
    "diamondCulet"   : translations.titleCulet+' - '+diamondData.culet,
    "diamondIntensity"  : translations.titleIntensity+' - '+diamond_intensity,
    "diamondOvartone"   : translations.titleOvertone+' - '+diamond_overtone,
  };
  //end

  //Diamond Information HTML Layout
  var detailInfo = '';
  if(diamondInformation != ''){
     var j = 1;
     $.each(diamondInformation, function(i, diamondInfo) {
       var diamondInfoArray = diamondInfo.split(" - ");
       if(diamondInfoArray.length > 1){
         var infoLable = diamondInfoArray[0];
         if(infoLable == 'Girdle'){
           if(diamondInfoArray.length == 3){
             var infoValue = diamondInfoArray[1]+' - '+diamondInfoArray[2];
           }else{
             var infoValue = diamondInfoArray[1];
           }           
         }else{
           var infoValue = diamondInfoArray[1];
         }
         
        
         if(diamondInfoArray[1] != ''){
           if(diamondInfoArray.length == 3 && infoLable != 'Girdle'){
             var infoUrl = diamondInfoArray[2];
             detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info"><a href="'+infoUrl+'" target="_blank" alt="Certificate URL" title="Certificate Title">'+infoValue+'</a></span></div> ';
           }else{
             if(infoValue != 'null' ){
               detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info">'+infoValue+'</span></div> ';
             }             
           } 
           j++;
         }
       }        
    });
  }
  //end
  
  return detailInfo;
}
/*** End ***/

/*** Config function forpre define module url start ***/
if(store_lang == 'de'){
  var tps_config = {
	"urls": {        
        "lab_diamond": "/pages/labor-weisser-diamant",
        "loose_color_diamond": "/pages/naturlicher-farbiger-diamant",
        "loose_diamond": "/pages/naturlicher-weisser-diamant",
        "loose_diamond_detail": "/pages/diamant-einzelheiten",
	}
  }
}else{
  var tps_config = {
	"urls": {        
        "loose_diamond": "/pages/natural-white-diamonds",
        "lab_diamond": "/pages/lab-grown-white-diamonds",
        "loose_color_diamond": "/pages/natural-color-diamonds", 
        "lab_color_diamond": "/pages/lab-grown-color-diamonds",
        "loose_diamond_detail": "/pages/loose-diamond-details",
	}

  }
}
/*** End ***/

/*** Show Product Detail & Final Ring Page Loader Start ***/
function showProductLoader(galleryStyle){
  if(galleryStyle == 'grid-view'){            
    if(jQuery(window).width() <= 767){
      jQuery(".tps-loader-horizontal-thumb-slider").show();
    }else{
      jQuery(".tps-loader-"+galleryStyle).show();
    }
  }else{
    jQuery(".tps-loader-"+galleryStyle).show();
  }
}
/*** Show Product Detail & Final Ring Page Loader End ***/

/*** Remove HTML Elements In Mobile ***/
function removeHtmlElementsInMobile() {  
  jQuery('.tps-mobile-hide').remove();	
}
/*** End ***/

/*** Remove HTML Elements In Desktop ***/
function removeHtmlElementsInDesktop() {
  jQuery('.tps-desktop-hide').remove();	
}
/*** End ***/

// document.addEventListener('DOMContentLoaded', function () {
//     document.body.classList.add('tps-lab-white-diamonds');
// });

// document.addEventListener('DOMContentLoaded', function () {
//     document.body.classList.add('tps-lab-color-diamonds');
// });

/*******
End
********/